import { Injectable } from '@angular/core';
import { ReducedProfile } from '@interfaces/profiles/reduced-profile';
// import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    constructor(
        // private authSrv: AuthService
    ) {
        window.addEventListener('storage', this.getCurrentProfile, false);
        this.requestSyncSessionStorage();

        // let referer = document.referrer;
        // console.log(' referer:', referer);
    }

    getCurrentProfile = (event: StorageEvent): void => {
        // console.log(event);
        if (event.key === 'requestSyncSessionStorage') {
            localStorage.setItem('sessionStorage', sessionStorage.getItem('current-profile'));
            localStorage.removeItem('sessionStorage');
        }
        else if (event.key === 'sessionStorage') {
            const currentProfile = JSON.parse(event.newValue) as ReducedProfile;
            if (currentProfile) {
                sessionStorage.setItem('current-profile', JSON.stringify(currentProfile));
            }
        }
    }

    requestSyncSessionStorage(): void {
        if (!sessionStorage.length) {
            const current = new Date().toLocaleTimeString();
            localStorage.setItem(
                'requestSyncSessionStorage',
                'request session storage ' + current
            );
        }
    }

}
